export default __webpack_public_path__ + "media/images/react_icons/cloud-download-18ac979bdd5443bcdecdd4b8b27dc6d9.svg";